"use client";
import * as index$b from "./svg/action/index.js";
import * as index$a from "./svg/communication/index.js";
import * as index$9 from "./svg/content/index.js";
import * as index$8 from "./svg/device/index.js";
import * as index$7 from "./svg/file/index.js";
import * as index$6 from "./svg/map/index.js";
import * as index$5 from "./svg/navigation/index.js";
import * as index$4 from "./svg/notifications/index.js";
import * as index from "./svg/search/index.js";
import * as index$3 from "./svg/social/index.js";
import * as index$2 from "./svg/toggle/index.js";
import * as index$1 from "./svg/validation/index.js";
function mergeIconsAndOptions(inputIcons, options) {
  const initial = {};
  return Object.entries(inputIcons).reduce((results, [icon, spec]) => ({
    ...results,
    [icon]: { ...spec, options: options[icon] }
  }), initial);
}
const defaultOptions = { fit: "height", scale: 2 / 3 };
function defineIcons(icons2) {
  const result = {};
  for (const key of Object.keys(icons2)) {
    const icon = key;
    const { options: definedOptions, ...variants } = icons2[icon];
    const options = { ...defaultOptions, ...definedOptions };
    result[icon] = {
      variants,
      options
    };
  }
  return result;
}
const icons = defineIcons(mergeIconsAndOptions({
  ...index$b,
  ...index$a,
  ...index$9,
  ...index$8,
  ...index$7,
  ...index$6,
  ...index$5,
  ...index$4,
  ...index$3,
  ...index$2,
  ...index$1,
  ...index
}, {
  // Action
  car: { fit: "width" },
  car_crash: { fit: "width" },
  code: { fit: "width" },
  visibility_on: { fit: "width" },
  visibility_off: { fit: "width" },
  // Navigation
  check: { fit: "width" },
  chevron_left: { scale: 0.5 },
  chevron_right: { scale: 0.5 },
  expand_less: { fit: "width", scale: 0.5 },
  expand_more: { fit: "width", scale: 0.5 },
  menu: { fit: "width" },
  more_horizontal: { fit: "width" },
  // Validation
  warning: { fit: "width" },
  // Content
  remove: { fit: "width", scale: 0.5 }
}));
export {
  defineIcons,
  icons
};
